import styled from 'styled-components';

export const RIDashboardStyles = styled.section`
  padding: 50px 0 0;

  .dashboard {
    padding: 80px 0;
  }
`;
